import { render, staticRenderFns } from "./JoinMinigame.vue?vue&type=template&id=6ad1309e"
import script from "./JoinMinigame.vue?vue&type=script&lang=js"
export * from "./JoinMinigame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports